import {
  Text,
  Box,
  TableContainer,
  Flex,
  Table,
  useToken,
} from "@chakra-ui/react";
import React, { Fragment, useState } from "react";
import PrimaryButton from "../../components/themeComponents/PrimaryButton";
import { useNavigate } from "react-router-dom";
import { useQuery, useQueryClient } from "react-query";
import { getFlowsList } from "../../Services/api";
import { OvalSpinner } from "../../components/Loaders";
import TableHead from "../Campaigns/components/TableHead";
import { prepareFlowListData } from "../../_helpers/data_helper";
import FlowListTable from "./components/FlowListTable";
import hexToRgba from "hex-to-rgba";
import FlowListFilter from "./components/FlowListFilter";
import OutlinedButton from "../../components/themeComponents/OutlinedButton";
import  Pagination  from "../../components/Pagination";

function FlowsList() {
  const navigate = useNavigate();
  const [mainColor] = useToken("colors", ["primary.main"]);
  const [totalCount, setTotalCount] = useState(0);
  const [campaignFilter, setCampaignFilter] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;
  const queryClient = useQueryClient();

  const flowQuery = useQuery(
    ["flowsList", currentPage, campaignFilter],
    async () => {
      const res = await getFlowsList(
        currentPage,
        campaignFilter.keyword,
        campaignFilter.status
      );
      setTotalCount(res?.data?.count ?? 0);
      return prepareFlowListData(res.data);
    },
    {
      retry: 1,
      cacheTime:0
      
      
    }
  );

  const toggleStatus = (status, uuid) => {
    const updatedData = flowQuery.data.map((item) =>
      item.uuid === uuid ? { ...item, status: !!status ? "true" : "false" } : item
    );
    queryClient.setQueryData(["flowsList", currentPage, campaignFilter], updatedData);
    // TODO: Add API call to persist status change on the server
  };

  return (
    <Fragment>
      <Box h="100%" overflowY="auto" overflowX={'hidden'} display="flex" flexDirection="column">
        <Box display="flex" alignItems="center" justifyContent="space-between" mt={1}>
          <Text fontSize="xl" as="b">
            Flows
          </Text>
          <OutlinedButton
            mb="5px"
            label="Create Campaign"
            onClick={() => navigate("/flows/predefined/list")}
          />
        </Box>
        <FlowListFilter onFilter={(dt) => setCampaignFilter(dt)} />
          <Table>

        <TableContainer bg="white" position="relative" p={3} overflowY="auto">
          {flowQuery.isLoading ? (
            <Flex justifyContent="center" alignItems="center" h="200px">
              <OvalSpinner width={50} height={50} />
            </Flex>
          ) : flowQuery.isError ? (
            <Flex direction="column" justifyContent="center" alignItems="center" py={10}>
              <Text fontSize="lg" fontWeight="bold" color="red.600">
                Error loading flows
              </Text>
              <Text fontSize="sm" color="gray.500" mt={2}>
                Please try again later or contact support.
              </Text>
              <PrimaryButton
                label="Retry"
                mt={4}
                onClick={() => flowQuery.refetch()}
                size="md"
                />
            </Flex>
          ) : flowQuery.data?.length > 0 ? (
            <>
              <TableHead zIndex="999" headersProps={["Name", "Timer", "Created", "Actions"]} />
              <FlowListTable list={flowQuery.data} refetch={() => flowQuery.refetch()} />
            </>
          ) : (
            <Flex direction="column" justifyContent="center" alignItems="center" py={10}>
              <Text fontSize="lg" fontWeight="bold" color="gray.600">
                No campaigns found for the selected date range.
              </Text>
              <Text fontSize="sm" color="gray.500" mt={2}>
                Create a campaign to automate your workflows and improve performance.
              </Text>
              <PrimaryButton
                label="Create Campaign Now"
                mt={4}
                onClick={() => navigate("/flows/predefined/list")}
                size="md"
                />
            </Flex>
          )}
        </TableContainer>
        </Table>
        {!flowQuery.isLoading && flowQuery.data?.length > 0 && (
          <Pagination
          totalCount={totalCount}
          currentPage={currentPage}
          pageSize={pageSize}
          onPageChange={setCurrentPage}
          isDisabled={flowQuery.isLoading}
          />
        )}
      </Box>
    </Fragment>
  );
}

export default FlowsList;